import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Bell, BellOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function EmailUpdatesSubscribe() {
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setIsLoggedIn(true);
      loadSubscriptionStatus();
    }
  }, []);

  const loadSubscriptionStatus = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/api/user/email-updates`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSubscribed(res.data.subscribed);
    } catch (error) {
      console.error('Failed to load subscription status:', error);
    }
  };

  const toggleSubscription = async () => {
    if (!isLoggedIn) {
      toast.error('Please log in to subscribe to updates');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        `${API_URL}/api/user/email-updates`,
        { subscribed: !subscribed },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSubscribed(!subscribed);
      toast.success(subscribed ? 'Unsubscribed from email updates' : 'Subscribed to email updates!');
    } catch (error) {
      toast.error('Failed to update subscription');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-neutral-900/50 border border-white/10 rounded-2xl p-6">
      <div className="flex items-center gap-4 mb-4">
        <div className="w-12 h-12 rounded-full bg-[#00F0FF]/20 flex items-center justify-center">
          <Bell className="w-6 h-6 text-[#00F0FF]" />
        </div>
        <div>
          <h3 className="font-bold">Email Updates</h3>
          <p className="text-sm text-neutral-400">Get notified about new products & deals</p>
        </div>
      </div>
      
      <Button
        onClick={toggleSubscription}
        disabled={loading}
        variant={subscribed ? 'outline' : 'default'}
        className={`w-full ${
          subscribed
            ? 'border-green-500 text-green-400'
            : 'bg-[#00F0FF] hover:bg-[#00C2CC] text-black'
        }`}
      >
        {subscribed ? (
          <>
            <Bell className="w-4 h-4 mr-2" />
            Subscribed to Updates
          </>
        ) : (
          <>
            <BellOff className="w-4 h-4 mr-2" />
            Get Email Updates
          </>
        )}
      </Button>
    </div>
  );
}

export default EmailUpdatesSubscribe;
